import AkCustomThemeButton from '@atlaskit/button/custom-theme-button';
import { asInstrumentedButton } from './asInstrumentedButton';

export default asInstrumentedButton(AkCustomThemeButton);
